const components = [];

const requireComponent = require.context(
  './',
  true,
  // 匹配基础组件文件名的正则表达式
  /\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)
  // 获取组件的 PascalCase 命名
  const componentName = fileName
    .split('/')
    .pop().replace('.vue', '')
  components.push(
    {name: componentName, comp: componentConfig.default || componentConfig}
  )
})
const install = function (Vue, opts = {}) {
  for (var i = 0; i < components.length; i++) {
    var component = components[i];
    Vue.component(component.name, component.comp);
  }
};
const to = {}
for (var i = 0; i < components.length; i++) {
  var component = components[i];
  to[component.name] = component.comp;
}
export default {install, ...to};



// WEBPACK FOOTER //
// ./src/components/index.js